// extracted by mini-css-extract-plugin
export var timetable = "timetable-module--timetable--lqasq";
export var allDatesButton = "timetable-module--all-dates-button--uU7AU";
export var icon = "timetable-module--icon--39abq";
export var row = "timetable-module--row--NRghE";
export var date = "timetable-module--date--3FTM8";
export var time = "timetable-module--time--1flb5";
export var remark = "timetable-module--remark---B24I";